import { render, staticRenderFns } from "./ApprovalMaterialityGl.vue?vue&type=template&id=e378f30a&scoped=true"
import script from "./ApprovalMaterialityGl.vue?vue&type=script&lang=js"
export * from "./ApprovalMaterialityGl.vue?vue&type=script&lang=js"
import style0 from "./ApprovalMaterialityGl.vue?vue&type=style&index=0&id=e378f30a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e378f30a",
  null
  
)

export default component.exports